import { createTranslations } from '@npco/utils-translations'

export const businessContactTranslations = createTranslations({
  errorRequired: 'Contact is required.',
})
